import { render, staticRenderFns } from "./SelfSelectedField.vue?vue&type=template&id=1eda43dd&scoped=true&"
import script from "./SelfSelectedField.vue?vue&type=script&lang=js&"
export * from "./SelfSelectedField.vue?vue&type=script&lang=js&"
import style0 from "./SelfSelectedField.vue?vue&type=style&index=0&id=1eda43dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eda43dd",
  null
  
)

export default component.exports